exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".single-tag {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  flex-wrap: nowrap;\n  border: 2px solid #32e37f;\n  border-radius: 30%/60%;\n  color: #32e37f;\n  font-size: 14px;\n  margin: 10px 10px;\n  height: 3em;\n  padding-left: 1em;\n  padding-right: 1em;\n  line-height: 2.5em;\n  font-weight: bold; }\n\n.single-tag > div {\n  margin: 10px 5px; }\n\n.tag-name {\n  line-height: 1.3em; }\n\n.delete-tag {\n  width: 15px;\n  height: 15px;\n  border-radius: 80%;\n  color: #32e37f;\n  line-height: .65;\n  border: 2px solid #32e37f; }\n", ""]);

// exports
